import { TAddressPayload } from 'types/address';

import { CRMAPIBase } from '@api/crmApiBase';
import { AddressListResp } from '@api/responseModels/addresses/addressListResponse';
import { AddressResp } from '@api/responseModels/addresses/addressResponse';
import { RequestResult } from '@api/responseModels/requestResult';

class AddressGroup extends CRMAPIBase {
    async getAddressList({ crm_id, page, per_page }): Promise<RequestResult<AddressListResp>> {
        const result = await this.get<AddressListResp>(`/addresses`, {
            crm_id,
            page,
            per_page,
        });
        return result;
    }

    async getAddress(id: number, crmId: number): Promise<RequestResult<AddressResp>> {
        const result = await this.get<AddressResp>(`/addresses/${id}`, { crm_id: crmId });
        return result;
    }

    async createAdress(
        params: TAddressPayload & { crm_id: number }
    ): Promise<RequestResult<AddressResp>> {
        const result = await this.post<AddressResp>('/addresses', params);
        return result;
    }

    async updateAddress(
        id: number,
        params: TAddressPayload & { crm_id: number }
    ): Promise<RequestResult<AddressResp>> {
        const result = await this.put<AddressResp>(`/addresses/${id}`, params);
        return result;
    }

    async deleteAddress(id: number, crmId: number): Promise<RequestResult<AddressResp>> {
        const result = await this.delete<AddressResp>(`/addresses/${id}`, { crm_id: crmId });
        return result;
    }
}

export { AddressGroup };
